import { Injectable } from '@angular/core';
import { FluxStandardAction } from 'flux-standard-action';
export type Action = FluxStandardAction<any, any>;

@Injectable()
export class CommonActions {
  /**
  * @arg Declaration of the action to store the error code
  **/
  static readonly SET_ERROR_CODE = 'SET_ERROR_CODE';
  /**
  * @arg Declaration of the action to store the table data
  **/
  static readonly SET_TABLE_DATA = 'SET_TABLE_DATA';
  /**
  * @arg Declaration of the action to store the table data
  **/
  static readonly SET_STEP = 'SET_STEP';
  /**
  * @arg Declaration of the action to store repsosne
  **/
  static readonly SET_GETRESPONSE = 'SET_GETRESPONSE';
  /**
  * @arg Declaration of the action to store the table data
  **/
  static readonly SET_FAILEDRECORDS = 'SET_FAILEDRECORDS';
  /**
   * @arg Declaration of the action to reset
   **/
  static readonly RESET = 'RESET';
  /**
  * @arg Declaration of the action to store the table data
  **/
  static readonly SET_SHOW_RESULTS = 'SET_SHOW_RESULTS';
  /**
   * @arg Declaration of the action to store the profile action
   **/
  static readonly SET_PROFILE = 'SET_PROFILE';
  /**
   * @method setErrorCode sets the error code
   * @param errorCode error code
   **/
  static setErrorCode(errorCode: string) {
    return {
      type: CommonActions.SET_ERROR_CODE,
      payload: { errorCode }
    };
  }
  /**
  * @method setTableData sets the table data
  * @param tableColumns column values
  * @param tableDataSource data source
  **/
  static setTableData(tableColumns: Array<string>, tableDataSource: Array<object>) {
    return {
      type: CommonActions.SET_TABLE_DATA,
      payload: { tableColumns, tableDataSource }
    };
  }
  /**
  * @method setStep sets the step view or upload
  * @param step step
  **/
  static setStep(step: string) {
    return {
      type: CommonActions.SET_STEP,
      payload: { step }
    };
  }
  /**
  * @method setGetResponse sets the get response from the api
  * @param getResponse getResponse
  **/
  static setGetResponse(getResponse: object) {
    return {
      type: CommonActions.SET_GETRESPONSE,
      payload: { getResponse }
    };
  }
  /**
  * @method setFailedRecords sets the failed records recieved as  response from the api
  * @param getFailedRecords getFailedRecords
  **/
  static setFailedRecords(getFailedRecords: object) {
    return {
      type: CommonActions.SET_FAILEDRECORDS,
      payload: { getFailedRecords }
    };
  }
  /**
  * @method reset sets the get response from the api
  **/
  static resetAll() {
    return {
      type: CommonActions.RESET,
      payload: {}
    };
  }
  /**
  * @method showResults shows results
  * @param showResults name of tab asi or package
  **/
  static showResults(showResults: string) {
    return {
      type: CommonActions.SET_SHOW_RESULTS,
      payload: { showResults: showResults }
    };
  }
  /**
  * @method setProfile sets profile vehicle or customer
  **/
  static setProfile(profile: string) {
    return {
      type: CommonActions.SET_PROFILE,
      payload: { profile: profile }
    };
  }

}
